/*
Documentation

all dispatch actions should be declared in this file and used

this prevents mis-typing action names as it will through an error
by either the browser or IDE

*/




//app reducer
export const SET_LOADING                        = 'SET_LOADING';

//system reducer
export const TOGGLE_SYSTEM_ALERT                = 'TOGGLE_SYSTEM_ALERT';
export const TOGGLE_SYSTEM_LOADER                = 'TOGGLE_SYSTEM_LOADER';

//article reducer
export const SET_APP_ARTICLES          = 'SET_APP_ARTICLES';



